//#region IMPORTS
import { updateApproveStateOfInstoreOrder } from "../../features/instoreOrders/instoreOrdersSlice";
import { useAppDispatch } from "../../store/configureStore";
import { InstoreOrder } from "../../models/instoreOrder";
import { useState } from "react";
import { Switch } from "@headlessui/react";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  instoreOrder: InstoreOrder;
  hide?: boolean;
}
//#endregion

export default function InstoreOrdersTableRowActionApproveToggle({
  instoreOrder,
  hide = false,
}: Props) {
  const dispatch = useAppDispatch();
  const [enabled, setEnabled] = useState(instoreOrder.approved !== false);

  const toggle = () => {
    const next = !enabled;
    setEnabled(next);
    dispatch(
      updateApproveStateOfInstoreOrder({
        id: instoreOrder.id,
        approved: next,
      }),
    );
  };

  return !hide ? (
    <Switch
      onChange={toggle}
      className="group relative inline-flex h-4 w-8 shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none"
    >
      <span className="pointer-events-none absolute size-full rounded-md bg-pink-500" />
      <span className="pointer-events-none absolute mx-auto h-3 w-7 rounded-full bg-gray-200 transition-colors duration-200 ease-in-out" />
      <span
        className={classNames(
          enabled ? "translate-x-4" : "translate-x-0",
          "pointer-events-none absolute left-0 inline-block h-4 w-4 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out",
        )}
      />
    </Switch>
  ) : null;
}
